import { Phone, Mail, MapPin, ArrowRight } from "lucide-react";
import { useSEO } from "../lib/seo";
import { useCmsSeo } from "../lib/cmsSeo";
import { BRAND } from "../data/content";

export default function ContactPage({ onBook }) {
  const seo = useCmsSeo("contact", {
    title: "Contact GenieX — Book a Private Consultation",
    description:
      "Speak with a GenieX advisor. Book a private consultation, visit our experience studio in Hyderabad, or call us directly.",
    path: "/contact",
    keywords: "contact GenieX, book consultation smart home, Hyderabad smart home studio",
  });
  useSEO(seo);

  return (
    <main data-testid="contact-page" className="bg-[var(--gx-bg)] text-white">
      <section className="relative pt-32 lg:pt-40 pb-16 lg:pb-20 grain">
        <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_top,rgba(201,169,97,0.12),transparent_60%)]" />
        <div className="relative max-w-[1400px] mx-auto px-5 lg:px-10">
          <p className="eyebrow mb-4">Contact</p>
          <h1 className="h1-display max-w-[18ch]">
            We would be<br />
            <span className="text-gold">delighted to help.</span>
          </h1>
          <p className="lead mt-6 max-w-[52ch]">
            Whether you're planning a new home, retrofitting an existing one, or commissioning a
            villa — our advisors are here for a private, no-obligation conversation.
          </p>
        </div>
      </section>

      <section className="border-t border-line">
        <div className="max-w-[1400px] mx-auto px-5 lg:px-10 py-16 lg:py-24 grid md:grid-cols-3 gap-6 lg:gap-8">
          <a
            href={`tel:${BRAND.phoneRaw}`}
            data-testid="contact-phone-card"
            className="rounded-3xl border border-line bg-[var(--gx-surface)] p-8 hover:border-gold/50 transition-colors"
          >
            <Phone className="w-5 h-5 text-gold" />
            <p className="eyebrow mt-5 text-mute">Call us</p>
            <p className="font-display text-2xl mt-2">{BRAND.phone}</p>
            <p className="text-dim text-[13px] mt-2">Mon – Sat · 10 AM – 8 PM IST</p>
          </a>
          <a
            href={`mailto:${BRAND.email}`}
            data-testid="contact-email-card"
            className="rounded-3xl border border-line bg-[var(--gx-surface)] p-8 hover:border-gold/50 transition-colors"
          >
            <Mail className="w-5 h-5 text-gold" />
            <p className="eyebrow mt-5 text-mute">Write to us</p>
            <p className="font-display text-2xl mt-2 break-all">{BRAND.email}</p>
            <p className="text-dim text-[13px] mt-2">We reply within 24 hours.</p>
          </a>
          <div className="rounded-3xl border border-line bg-[var(--gx-surface)] p-8">
            <MapPin className="w-5 h-5 text-gold" />
            <p className="eyebrow mt-5 text-mute">Visit us</p>
            <p className="font-display text-2xl mt-2">{BRAND.address}</p>
            <p className="text-dim text-[13px] mt-2">By appointment only.</p>
          </div>
        </div>
      </section>

      <section className="border-t border-line bg-[var(--gx-black)]">
        <div className="max-w-[1400px] mx-auto px-5 lg:px-10 py-16 lg:py-24 text-center">
          <h2 className="h2-display max-w-[22ch] mx-auto">Book a private consultation.</h2>
          <p className="lead mt-6 max-w-[44ch] mx-auto">
            One of our advisors will reach out within a business day.
          </p>
          <button onClick={onBook} data-testid="contact-book-cta" className="btn-gold mt-9 mx-auto">
            Book Consultation <ArrowRight className="w-4 h-4" />
          </button>
        </div>
      </section>
    </main>
  );
}
